<template>
    <CModal
      :color="color"
      :show.sync="showModal"
    >   
    <template #header>
      <CRow style="width: 100%; height: 5px;">
        <CCol md="9">{{title}}</CCol>
        <CCol md="3">
          
        </CCol>
      </CRow>
      <CButtonClose @click="showModal = false"/>            
    </template>
      <CRow>      
        <CCol md="12" style="text-align: center; margin: auto; font-size: 24px;">
          {{ freelancer.contrasena }}
        </CCol>           
      </CRow>      
        <template #footer>
          <CButton @click="closeModal" :color="color">Cerrar Ventana</CButton>
        </template>
    </CModal>
</template>

<script>
import store from '../../store';
import ws from '../../services/freelancers';

export default {
  name: 'ShowPasswordModal',
  props: {
    fields: {
      type: Array,
      default () {
        return [
          {key: 'position', label: 'N°' ,_style:"font-size: 12px;"},
          {key: 'name', label: 'Nombre',_style:"font-size: 12px;"},
          {key: 'last_name', label: 'Apellido',_style:"font-size: 12px;"},
          {key: 'nickname', label: 'Apodo',_style:"font-size: 12px;"},
          {key: 'phone', label: 'Whatsapp',_style:"font-size: 12px;"},
          {key: 'email', label: 'Email',_style:"font-size: 12px;"},
          {key: 'tickets', label: 'Invitados',_style:"font-size: 12px;"},
          {key: 'table', label: 'Mesa',_style:"font-size: 12px;"},
          {key: 'is_confirm', label: 'Confirmación',_style:"font-size: 12px;"},
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  components: {
  },
  data () {
    return {
      showModal: false,
      title: "Aprobar Visita",
      color: "success",
      submitted: false,      
      freelancer: false,
      message: ""
    }
  },
  mounted: async function() {    
    
  },
  methods: {
    async showPasswordModal (freelancer) {
      this.freelancer = freelancer;
      this.message = "";

      this.loading();

        this.showModal = true;
        this.color = "success";
        this.title = 'Ver Contraseña';
        this.isEdit = false;
        this.submitted = false;

      this.loaded();

    },
    closeModal () {
      this.showModal = false;

      this.submitted = false
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
}
</script>
<style>
.basic-modal-color .modal-header{
  background-color: #668269 !important;
}
.crema{
  background-color: #F4F0E5;
  color: black;
}
</style>